import React from 'react';
import '../../styles/components/Cta.css';

function Button({ type, name, onClick, transparent, icon, style, disabled }) {
    let buttonClass = '';

    switch (type) {
        case 'toggle':
            buttonClass = transparent ? 'cta-btn transparent' : 'cta-btn';
            break;
        case 'filter':
            buttonClass = 'filter-btn';
            break;
        case 'primary':
            buttonClass = disabled ? 'primary-btn disabled' : 'primary-btn';
            break;
        case 'secondary':
            buttonClass = disabled ? 'secondary-btn disabled' : 'secondary-btn';
            break;
        default:
            buttonClass = 'cta-btn';
    }

    return (
        <button className={buttonClass} onClick={onClick} style={{ ...style }}>
            {icon && <span className="cta-icon">{icon}</span>}
            {name}
        </button>
    );
}

export const PrimaryBtn = (props) => <Button type="primary" {...props} />;
export const ToggleButton = (props) => <Button type="toggle" {...props} />;
export const SecondaryBtn = (props) => <Button type="secondary" {...props} />;
export const FilterBtn = (props) => <Button type="filter" {...props} />;
